/* eslint-disable */
import React from 'react'

const Assets = () => {
    return (
        <div>Asset</div>
    )
}

export default Assets